import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const QUERY_VALUE_SCHEMA = Object.freeze({
  LABEL: '',
  VALUE: null, // any
  SELECTED: false,
});
const RECORD = generateSchema(QUERY_VALUE_SCHEMA);
const KEYS: any = generateKeys(QUERY_VALUE_SCHEMA);

export class QueryValue extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get label(): string {
    return this.get(KEYS.LABEL);
  }

  get value(): any {
    return this.get(KEYS.VALUE);
  }

  get selected(): boolean {
    return this.get(KEYS.SELECTED);
  }
}
